<template><div><h1 id="e-kommunikation" tabindex="-1"><a class="header-anchor" href="#e-kommunikation"><span>E-Kommunikation</span></a></h1>
<p>E-Kommunikation — Status- und Log für E-Mail Versand aus funtrade</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Der Versand von E-Mails aus funtrade kann über verschiedene Systeme laufen. Auf jeden Fall dokumentiert funtrade den Versand und den zugehörigen Geschäftsfall in der Tabelle E-Kommunikation.</p>
<p>Pfad: <code v-pre>Datenaustausch → E-Kommunikation</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Job-ID</dt>
<dd>ID von internen Jobs, die E-Mails versenden.</dd>
<dt>Jobnr.</dt>
<dd>Eindeutige Nummer des E-Mail Versands.</dd>
<dt>Personen-ID</dt>
<dd>Die Person, die angeschrieben wurde.</dd>
<dt>E-Mail</dt>
<dd>Die verwendete E-Mail Adresse.</dd>
<dt>Status</dt>
<dd>Status des Versands. Wichtig sind &quot;automatisch&quot; (= erfolgreicher Versand), &quot;pendent&quot; (= das System wird das Mail in Kürze senden), &quot;bounced&quot; und &quot;fehlerhaft&quot;. Andere Stati sind alt und werden nicht mehr verwendet.</dd>
<dt>XML-Inhalt</dt>
<dd>Steuerdaten (intern) für die Aufbereitung des E-Mails.</dd>
<dt>Infos zu Bounces</dt>
<dd>Falls das Bounce-Management installiert ist, erscheinen hier Infos zu allfälligen Bounces.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/email_bounces_management.html">Bounces Management</RouteLink> <RouteLink to="/manual/administration/dokumentproduktion.html">Document Output</RouteLink></p>
</div></template>


